export default {
  title: "SORU2",
  text: `Mevsim kış, ortalık soğuk. İstiyoruz ki bir helva sohbeti yapalım. Kış günlerine uygun düşer. Bildiğiniz helva, tahin helvası... Kışın yenir. Yazın yiyene de yasak yok. Olsa da yesek diyenler vardır. Lezzeti güzeldir. Eskiden sohbeti de güzelmiş. Amaç sohbet, helva bahane. "Tatlı yiyelim, tatlı söyleyelim." deyip helva sohbetine bir giriş yapalım. Sabırla koruk, helva olurmuş. Ama helva helva demekle ağız tatlanmazmış. Sohbet için sohbet ehli dostlar gerektiğini biliyoruz. Bu yüzden de helva eşliğinde tatlı sohbetler yapacak dostlar arıyoruz.`
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/lgs/2.js